import { emeraldRequest } from 'src/common/api/emerald-request';
import { ITenderAdd } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { IReceiptArgs } from 'src/common/interfaces/dtos/IReceiptArgs';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { getReceiptPreferences } from './get-receipt-preferences';

export const refundAdd = async (
  transactionId: string,
  lineTenders: ITenderAdd,
  receiptArgs?: IReceiptArgs,
): Promise<CartResponse> => {
  lineTenders.receiptPreferences = receiptArgs ? getReceiptPreferences(receiptArgs) : undefined;
  const configObject: EmeraldRequestParams = {
    config: {
      url: `/returns/${transactionId}/refund`,
      method: 'POST',
      data: lineTenders,
    },
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };
  return emeraldRequest<CartResponse>(configObject);
};
